<template>
  <v-text-field
    :value="value"
    :label="sPlaceholder"
    :append-icon="'mdi-backspace-outline'"
    background-color="white"
    flat
    hide-details
    rounded
    dense
    tile
    outlined
    class="container-search"
    id="InputBusquedaRapida"
    @click:append="onLimpiarBusquedaRapida"
    @keyup.enter="onInput"
    @input="onInput"
    autocomplete="off"
    >
  </v-text-field>
</template>

<script>
  export default {
    name: 'Buscador',
    components:{
    },
    props: {
      value: String,
      sPlaceholder: String,
    },
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      onLimpiarBusquedaRapida(){
        this.$emit('input', null);
        this.$emit('onBuscarDato', null);
      },
      onInput(val) {
        this.$emit('input', val); // Necesario para v-model
        this.$emit('onBuscarDato', val); // Opcional, si querés ejecutar lógica extra
      }
    },
    
  }
</script>

<style lang="scss" scoped>
// corrige un margin negativo que está declarado en algún lugar del universo de vuetify 
.row {
  margin: 0!important;
}
.cont-resp-texto{
  font-size: 0.8em;
}
.under-sec{
  padding: 2px!important;
}
.btn-img{
  border-radius: 10px;
  img{
    width: 100%;
  }
}

.margin-auto{
  margin: 0 auto;
}
</style>